// Периодът на трите справки за резервации → query параметрите на заявката.
//
// Изнесено, за да не се повтаря в три страници. Форматът е същият като на
// останалите справки („YYYY-MM-DD HH:mm:ss", локално време — BE го тълкува по
// `settings.TIMEZONE`). Без период → без параметри (BE ги иска и връща 422),
// но `useReportsDateParam` винаги дава период, така че това е само защита.

import { useMemo } from "react";
import type { Dayjs } from "dayjs";

import type { ReservationReportFilters } from "../../../../api/reportsReservations";

export const useReservationPeriodFilters = (
  dateRange: [Dayjs, Dayjs] | null,
): ReservationReportFilters =>
  useMemo(() => {
    const params: ReservationReportFilters = {};
    if (dateRange?.[0] && dateRange?.[1]) {
      params.start_date = dateRange[0].format("YYYY-MM-DD HH:mm:ss");
      params.end_date = dateRange[1].format("YYYY-MM-DD HH:mm:ss");
    }
    return params;
  }, [dateRange]);
